/**
 * Funciones de formato y cálculo de montos.
 */

/** Formatea número como moneda MXN sin decimales */
export const fmt = (n) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
  }).format(n || 0);

/** Suma el campo `monto` de un arreglo */
export const sum = (arr) =>
  arr.reduce((s, x) => s + (Number(x.monto) || 0), 0);

/** Suma gastos fijos considerando monto pagado si ya fue pagado */
export const sumFijosReal = (arr) =>
  arr.reduce((s, x) => {
    if (x.pagado) {
      return s + (x.montoPagado != null ? Number(x.montoPagado) : Number(x.monto));
    }
    return s + (Number(x.monto) || 0);
  }, 0);
